import React from 'react';
import { useEffect, useState } from "react";
import AdminHeaderComponent from '../common/header/admin-header/AdminHeaderComponent';
import HomeFooterComponent from '../common/footer/homefooter/HomeFooterView';

function AdminLayout(props) {

    useEffect(() => {

      const header = document.getElementById("myHeader");
      const sticky = header.offsetTop;
      const scrollCallBack = window.addEventListener("scroll", () => {
        if (window.pageYOffset > sticky) {
          header.classList.add("admin__sticky");
        } else {
          header.classList.remove("admin__sticky");
        }
      });
      return () => {
        window.removeEventListener("scroll", scrollCallBack);
      };
    }, []);
  
    return (
      <div>
        <header id="myHeader" className="admin__header">
        <AdminHeaderComponent  />
        </header>
        <div className='inner-body-section'>
                     {props.children}
                 </div>
        {/* <HomeFooterComponent /> */}
      </div>
    );
  }
  
  export default AdminLayout;
  
